import { createAction } from "@reduxjs/toolkit";
import {
    GET_LINK_RESTRICTION,
    GET_SOURCE_IDS,
    LINK_RESTRICTION_RECEIVED,
    RECEIVED_SOURCE_IDS,
    TOGGLE_RIGHT1_PANEL,
    TOGGLE_SEGMENT_INFO_EXPANDED,
    GetLinkRestriction,
    LinkRestrictionReceived,
    ToggleRight1Panel,
    GetSourceIds,
    ReceivedSourceIds,
    ToggleSegmentInfoExpanded
} from "./types";

export const getLinkRestriction = createAction<GetLinkRestriction["payload"]>(GET_LINK_RESTRICTION);

export const linkRestrictionReceived =
    createAction<LinkRestrictionReceived["payload"]>(LINK_RESTRICTION_RECEIVED);

export const toggleRight1Panel = createAction<ToggleRight1Panel["payload"]>(TOGGLE_RIGHT1_PANEL);

export const getSourceIds = createAction<GetSourceIds["payload"]>(GET_SOURCE_IDS);

export const receivedSourceIds = createAction<ReceivedSourceIds["payload"]>(RECEIVED_SOURCE_IDS);

export const toggleSegmentInfoExpanded = createAction<ToggleSegmentInfoExpanded["payload"]>(
    TOGGLE_SEGMENT_INFO_EXPANDED
);
